import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  icon: "face",
  contact_icon: "account_circle",
  clients: [],
  client: {},
  clientContacts: [],
  clientContact: {},
  sites: [],
  site: {},
  buildings: [],
  building: {},
  plants: [],
  plant: {},
  plantTypes: [],
  consultant: {},
  consultants: []
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
